<template>
  <dialog-v2
    :show="show"
    title="Agregar grupo de condiciones"
    max-width="700px"
    @close="closeDialog"
    @save="save">
    <template slot="content">
      <template v-if="!isSpecialField">
        <v-layout row wrap align-center>
          <v-flex md4 pr-2 class="filter-field-with-help">
            <v-select
              v-model="form.field"
              :items="filtersAndAmounts"
              item-text="title"
              item-value="field"
              class="grey"
              color="black"
              label="Filtros"
              flat
              solo
              autocomplete/>
            <v-tooltip v-if="currentFilterTooltip" left max-width="320">
              <v-btn slot="activator" icon small flat class="ma-0 filter-help-btn">
                <v-icon small color="blue-grey lighten-2">fas fa-question-circle</v-icon>
              </v-btn>
              <div style="line-height:1.5" v-html="currentFilterTooltip"></div>
            </v-tooltip>
          </v-flex>
          <v-flex md4 pr-2>
            <v-select
              v-model="form.operator"
              :items="filteredComparisonOperators"
              class="grey"
              color="black"
              label="Condición"
              flat
              solo
              autocomplete/>
          </v-flex>
          <v-flex md3>
            <v-select
              v-if="!selectedFieldIsAmount && !selectedFieldIsInfo && !isNewNumericField && form.field !== 'delinquency' && form.field !== 'first_delinquency' && form.field !== 'calendar_day' && form.field !== 'broken_promises' && form.field !== 'payment_promise' && form.field !== 'last_notification' && !form.field.includes('_sync_date')"
              v-model="form.value"
              :items="valuesList"
              class="grey"
              color="black"
              label="Valor"
              flat
              solo
              autocomplete/>
            <v-menu
              v-else-if="form.field.includes('_sync_date')"
              ref="calendar"
              :close-on-content-click="false"
              v-model="calendar"
              :nudge-right="40"
              :return-value.sync="form.value"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px">
              <v-text-field
                slot="activator"
                :value="formatDate(form.value, 'YYYY-MM-DD', 'DD/MM/YYYY')"
                color="black"
                class="grey"
                label="Valor"
                flat
                solo
                readonly/>
              <v-date-picker
                v-model="form.value"
                @input="$refs.calendar.save(form.value)"
                color="k-orange-linear"/>
            </v-menu>
            <v-text-field
              v-else-if="selectedFieldIsAmount || isNewNumericField || form.field === 'delinquency' || form.field === 'first_delinquency' || form.field === 'calendar_day' || form.field === 'broken_promises'"
              v-model.number="form.value"
              class="grey"
              color="black"
              label="Valor"
              flat
              solo/>
            <v-menu
              v-else-if="form.field === 'payment_promise' || form.field === 'last_notification'"
              ref="calendarDate"
              :close-on-content-click="false"
              v-model="calendarDate"
              :nudge-right="40"
              :return-value.sync="form.value"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px">
              <v-text-field
                slot="activator"
                :value="formatDate(form.value, 'YYYY-MM-DD', 'DD/MM/YYYY')"
                color="black"
                class="grey"
                label="Valor"
                flat
                solo
                readonly/>
              <v-date-picker
                v-model="form.value"
                @input="$refs.calendarDate.save(form.value)"
                color="k-orange-linear"/>
            </v-menu>
            <v-text-field
              v-else
              v-model="form.value"
              class="grey"
              color="black"
              label="Valor"
              flat
              solo/>
          </v-flex>
          <v-flex md1 pr-0 text-xs-center>
            <v-btn @click="addItem" id="save-button" class="ma-0 k-orange-linear" depressed small>
              <v-icon small>
                fas fa-check
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template v-else-if="isBestNsField">
        <v-layout column class="best-ns-form">
          <v-layout row wrap>
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box best-ns-field-box--flex">
                <v-select
                  v-model="form.field"
                  :items="filtersAndAmounts"
                  item-text="title"
                  item-value="field"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Filtros"
                  flat
                  solo
                  hide-details
                  autocomplete/>
                <v-tooltip v-if="currentFilterTooltip" left max-width="320">
                  <v-btn slot="activator" icon small flat class="ma-0 filter-help-btn">
                    <v-icon small color="blue-grey lighten-2">fas fa-question-circle</v-icon>
                  </v-btn>
                  <div style="line-height:1.5" v-html="currentFilterTooltip"></div>
                </v-tooltip>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box">
                <v-select
                  v-model="form.bestNsChannelIds"
                  :items="channels"
                  item-text="channel"
                  item-value="id"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Canal"
                  flat
                  solo
                  hide-details
                  autocomplete
                  multiple
                  chips
                  clearable/>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-md-2">
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box">
                <v-select
                  v-model="form.bestNsMonths"
                  :items="bestNsTimeOptions"
                  item-text="text"
                  item-value="value"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Tiempo"
                  flat
                  solo
                  hide-details
                  autocomplete
                  clearable/>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box">
                <v-select
                  v-model="form.bestNsStatusIds"
                  :items="statuses"
                  item-text="status"
                  item-value="id"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Estados"
                  flat
                  solo
                  hide-details
                  autocomplete
                  multiple
                  chips
                  clearable/>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row justify-end mt-2>
            <v-flex shrink pr-0 text-xs-right>
              <v-btn @click="addItem" id="save-button" class="ma-0 k-orange-linear" depressed small>
                <v-icon small>
                  fas fa-check
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </template>
      <template v-else-if="isChannelJourneyField">
        <v-layout column class="best-ns-form">
          <v-layout row wrap>
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box best-ns-field-box--flex">
                <v-select
                  v-model="form.field"
                  :items="filtersAndAmounts"
                  item-text="title"
                  item-value="field"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Filtros"
                  flat solo hide-details autocomplete/>
                <v-tooltip v-if="currentFilterTooltip" left max-width="320">
                  <v-btn slot="activator" icon small flat class="ma-0 filter-help-btn">
                    <v-icon small color="blue-grey lighten-2">fas fa-question-circle</v-icon>
                  </v-btn>
                  <div style="line-height:1.5" v-html="currentFilterTooltip"></div>
                </v-tooltip>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box">
                <v-select
                  v-model="form.channelJourneyChannelIds"
                  :items="channelsWithGeneral"
                  item-text="channel"
                  item-value="id"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Canal"
                  flat solo hide-details autocomplete
                  multiple chips clearable/>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-md-2">
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box">
                <v-select
                  v-model="form.channelJourneyMonth"
                  :items="channelJourneyMonthOptions"
                  item-text="text"
                  item-value="value"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Mes"
                  flat solo hide-details autocomplete clearable/>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box">
                <v-select
                  v-model="form.channelJourneyJourneys"
                  :items="journeyOptions"
                  item-text="text"
                  item-value="value"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Etapa del funnel"
                  flat solo hide-details
                  multiple chips clearable/>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row justify-end mt-2>
            <v-flex shrink pr-0 text-xs-right>
              <v-btn @click="addItem" id="save-button" class="ma-0 k-orange-linear" depressed small>
                <v-icon small>fas fa-check</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </template>
      <template v-else-if="isChannelDaysField">
        <v-layout column class="best-ns-form">
          <v-layout row wrap>
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box best-ns-field-box--flex">
                <v-select
                  v-model="form.field"
                  :items="filtersAndAmounts"
                  item-text="title"
                  item-value="field"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Filtros"
                  flat solo hide-details autocomplete/>
                <v-tooltip v-if="currentFilterTooltip" left max-width="320">
                  <v-btn slot="activator" icon small flat class="ma-0 filter-help-btn">
                    <v-icon small color="blue-grey lighten-2">fas fa-question-circle</v-icon>
                  </v-btn>
                  <div style="line-height:1.5" v-html="currentFilterTooltip"></div>
                </v-tooltip>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box">
                <v-select
                  v-model="form.channelDaysChannelIds"
                  :items="channelsWithGeneral"
                  item-text="channel"
                  item-value="id"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Canal"
                  flat solo hide-details autocomplete
                  multiple chips clearable/>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-md-2">
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box">
                <v-select
                  v-model="form.operator"
                  :items="channelDaysOperatorOptions"
                  item-text="text"
                  item-value="value"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Condición"
                  flat solo hide-details autocomplete clearable/>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6 class="best-ns-field-cell">
              <div class="best-ns-field-box">
                <v-text-field
                  v-model.number="form.channelDaysDays"
                  class="grey best-ns-select-input"
                  color="black"
                  label="Días"
                  type="number"
                  flat solo hide-details/>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row justify-end mt-2>
            <v-flex shrink pr-0 text-xs-right>
              <v-btn @click="addItem" id="save-button" class="ma-0 k-orange-linear" depressed small>
                <v-icon small>fas fa-check</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </template>
      <v-layout row wrap v-if="conditions.length > 1">
        <v-flex offset-xs5 xs2>
          <v-radio-group row v-model="logicalOperator" :hide-details="true">
            <v-radio label="Y" value="and" />
            <v-radio label="O" value="or" />
          </v-radio-group>
        </v-flex>
      </v-layout>
      <div v-if="conditions.length" class="conditions-list mt-3">
        <scrollbar style="height: 150px;">
          <template v-for="(item, i) in conditions">
            <div :key="`condition-${i}`" class="condition-row">
              <div class="condition-name">
                <h4>{{ getfilterAndAmountTitle(item.field) }}</h4>
              </div>
              <div v-if="item.operator && item.operator !== 'in'" class="condition-operator">
                {{ getOperatorName(item.operator) }}
              </div>
              <div class="condition-value">
                {{ parseFilterValue(item.field, item.value) }}
              </div>
              <div class="condition-actions">
                <v-tooltip v-if="getFilterTooltip(item.field)" left max-width="320">
                  <v-btn slot="activator" icon small flat class="ma-0 filter-help-btn">
                    <v-icon small color="blue-grey lighten-2">fas fa-question-circle</v-icon>
                  </v-btn>
                  <div style="line-height:1.5" v-html="getFilterTooltip(item.field)"></div>
                </v-tooltip>
                <v-btn class="k-orange-linear" @click="deleteItem(i)" small icon round>
                  <v-icon small>fas fa-times</v-icon>
                </v-btn>
              </div>
            </div>
          </template>
        </scrollbar>
      </div>
      <v-layout v-else row wrap mt-4 justify-space-between align-center>
        <v-flex xs12 class="text-xs-center">
          <v-icon small class="mr-1 mb-1">
            fas fa-info-circle
          </v-icon>
          <h3 class="d-inline-block">
            No hay filtros que mostrar
          </h3>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import { setTimeout } from 'timers';
import Scrollbar from 'vue-perfect-scrollbar';
import DialogV2 from '@/components/global/DialogV2';
import filtersMixin from '@/mixins/workflowFilters';
import EventBus from '@/event-bus';
import comparisonOperatorsMixin from '@/mixins/comparisonOperators';
import { mapGetters } from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    group: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    DialogV2,
    Scrollbar,
  },
  mixins: [
    filtersMixin,
    comparisonOperatorsMixin,
  ],
  data() {
    const emptyForm = {
      field: '',
      operator: '',
      value: '',
      bestNsChannelIds: [],
      bestNsMonths: null,
      bestNsStatusIds: [],
      channelJourneyChannelIds: [],
      channelJourneyMonth: null,
      channelJourneyJourneys: [],
      channelDaysChannelIds: [],
      channelDaysDays: null,
    };
    return {
      emptyForm,
      calendar: false,
      calendarDate: false,
      logicalOperator: 'and',
      form: { ...emptyForm },
      conditions: [],
      channelJourneyMonthOptions: [
        { text: 'Mes actual', value: 0 },
        { text: 'Últimos dos meses', value: 1 },
        { text: 'Últimos tres meses', value: 2 },
        { text: 'Últimos cuatro meses', value: 3 },
        { text: 'Últimos cinco meses', value: 4 },
      ],
      journeyOptions: [
        { text: 'Barrido general', value: 2 },
        { text: 'Barrido exitoso', value: 3 },
        { text: 'Conexión', value: 4 },
        { text: 'Contacto', value: 5 },
        { text: 'Contacto directo', value: 6 },
        { text: 'Compromiso', value: 7 },
      ],
      channelDaysOperatorOptions: [
        { text: 'Mayor o igual que', value: '>=' },
        { text: 'Menor o igual que', value: '<=' },
        { text: 'Igual', value: '=' },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'channels',
      'statuses',
    ]),
    channelsWithGeneral() {
      return [{ id: 0, channel: 'General (todos)' }, ...this.channels];
    },
    isBestNsField() {
      return this.form.field === 'best_ns';
    },
    isChannelJourneyField() {
      return this.form.field === 'best_cs_journey';
    },
    isChannelDaysField() {
      return this.form.field === 'first_mgmt_days' || this.form.field === 'last_mgmt_days';
    },
    isNewNumericField() {
      return this.form.field === 'first_sync_days' || this.form.field === 'payment_intention_days';
    },
    isSpecialField() {
      return this.isBestNsField || this.isChannelJourneyField || this.isChannelDaysField;
    },
    currentFilterTooltip() {
      return this.getFilterTooltip(this.form.field);
    },
    bestNsTimeOptions() {
      return [
        { text: 'Mes actual', value: 0 },
        { text: 'Últimos dos meses', value: 1 },
        { text: 'Últimos tres meses', value: 2 },
        { text: 'Últimos cuatro meses', value: 3 },
        { text: 'Últimos cinco meses', value: 4 },
      ];
    },
    selectedFieldIsInfo() {
      return this.form.field.includes('info_') || this.form.field === 'portfolio_benchmark';
    },
    selectedFieldIsAmount() {
      return this.amountFieldsMapped.includes(this.form.field);
    },
    filteredComparisonOperators() {
      if (this.form.field === '') return [];
      if (this.isNewNumericField) {
        return this.comparisonOperators.filter(op => ['>=', '<=', '='].includes(op.value));
      }
      return this.comparisonOperators.filter((item) => {
        if (
          !this.selectedFieldIsAmount
          && this.form.field !== 'delinquency'
          && this.form.field !== 'first_delinquency'
          && this.form.field !== 'calendar_day'
          && this.form.field !== 'broken_promises'
          && (
            item.value === '>' ||
            item.value === '<' ||
            item.value === '>=' ||
            item.value === '<='
          )
        ) {
          return false;
        }
        return true;
      });
    },
    valuesList() {
      // eslint-disable-next-line
      return ((this.filtersAndAmounts.find(item => item.field === this.form.field) || {}).items || [])
        .map(item => ({
          text: item.name,
          value: item.id,
        }));
    },
  },
  methods: {
    addItem() {
      if (this.form.field === 'best_ns') {
        const { bestNsChannelIds, bestNsMonths, bestNsStatusIds } = this.form;
        const statusIds = Array.isArray(bestNsStatusIds)
          ? bestNsStatusIds.filter(id => id != null && id !== '')
          : [];
        const channelIds = Array.isArray(bestNsChannelIds)
          ? bestNsChannelIds.filter(id => id != null)
          : [];
        if (
          channelIds.length > 0
          && bestNsMonths != null && bestNsMonths !== ''
          && statusIds.length > 0
        ) {
          this.conditions.push({
            field: 'best_ns',
            operator: '=',
            value: { channel_ids: channelIds.slice(), months: bestNsMonths, status_id: statusIds.slice() },
          });
          this.form = { ...this.emptyForm };
        }
        return;
      }
      if (this.form.field === 'best_cs_journey') {
        const { channelJourneyChannelIds, channelJourneyMonth, channelJourneyJourneys } = this.form;
        const journeys = Array.isArray(channelJourneyJourneys)
          ? channelJourneyJourneys.filter(j => j != null)
          : [];
        const channelIds = Array.isArray(channelJourneyChannelIds)
          ? channelJourneyChannelIds.filter(id => id != null)
          : [];
        if (
          channelIds.length > 0
          && channelJourneyMonth != null && channelJourneyMonth !== ''
          && journeys.length > 0
        ) {
          this.conditions.push({
            field: 'best_cs_journey',
            operator: 'in',
            value: { channel_ids: channelIds.slice(), month: channelJourneyMonth, journeys: journeys.slice() },
          });
          this.form = { ...this.emptyForm };
        }
        return;
      }
      if (this.isChannelDaysField) {
        const { field, operator, channelDaysChannelIds, channelDaysDays } = this.form;
        const channelIds = Array.isArray(channelDaysChannelIds)
          ? channelDaysChannelIds.filter(id => id != null)
          : [];
        if (
          channelIds.length > 0
          && operator != null && operator !== ''
          && channelDaysDays != null && channelDaysDays !== ''
        ) {
          this.conditions.push({
            field,
            operator,
            value: { channel_ids: channelIds.slice(), days: channelDaysDays },
          });
          this.form = { ...this.emptyForm };
        }
        return;
      }
      if (this.form.field && this.form.operator && String(this.form.value).trim() !== '') {
        const item = { field: this.form.field, operator: this.form.operator, value: this.form.value };
        if (item.field === 'partial_refinancing' || item.field === 'total_refinancing') {
          item.value = parseInt(item.value, 10);
        }
        this.conditions.push(item);
        this.form = { ...this.emptyForm };
      }
    },
    deleteItem(i) {
      this.conditions.splice(i, 1);
    },
    closeDialog() {
      this.$emit('close');
      setTimeout(() => {
        this.conditions = [];
        this.form = { ...this.emptyForm };
        this.logicalOperator = 'and';
      }, 200);
    },
    save() {
      if (this.conditions.length) {
        let event = 'new-group';
        if (Object.keys(this.group).length) {
          event = 'group-edited';
        }
        this.$emit(event, {
          operator: this.logicalOperator,
          items: this.conditions,
        });
        this.closeDialog();
      } else {
        EventBus.$emit('modal', 'Debe activar al menos un filtro');
      }
    },
  },
  watch: {
    show() {
      if (this.show && Object.keys(this.group).length) {
        this.logicalOperator = this.group.operator;
        this.conditions = [
          ...this.group.items,
        ];
      }
    },
    'form.field'() { // eslint-disable-line
      const field = this.form.field;
      this.form = { ...this.emptyForm, field };
    },
  },
};
</script>

<style scoped>
#save-button {
  min-width: unset;
}
.grey {
  background-color: #eee !important;
}
.best-ns-form {
  width: 100%;
}
.best-ns-field-cell {
  padding: 6px !important;
}
.best-ns-field-box {
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  padding: 6px 8px 2px;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}
.best-ns-form .best-ns-select-input >>> .v-input__control {
  min-height: 40px;
}
.best-ns-form .best-ns-select-input >>> .v-input__slot {
  border-radius: 4px !important;
  box-shadow: inset 0 0 0 1px #e0e0e0 !important;
}
.best-ns-field-box--flex {
  display: flex;
  align-items: center;
}
.best-ns-field-box--flex .best-ns-select-input {
  flex: 1;
  min-width: 0;
}
.filter-field-with-help {
  display: flex !important;
  align-items: center;
}
.filter-field-with-help .v-select {
  flex: 1;
  min-width: 0;
}
.filter-help-btn {
  flex-shrink: 0;
  min-width: 28px !important;
  height: 28px !important;
}
.conditions-list {
  padding: 0 4px;
}
.condition-row {
  display: flex;
  align-items: center;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 6px 8px;
  margin-bottom: 6px;
  gap: 8px;
}
.condition-name {
  flex: 0 0 155px;
  min-width: 0;
}
.condition-name h4 {
  margin: 0;
  font-size: 13px;
  white-space: normal;
  word-break: break-word;
}
.condition-operator {
  flex: 0 0 auto;
  font-size: 12px;
  color: #78909c;
  padding: 0 8px;
  white-space: nowrap;
}
.condition-value {
  flex: 1;
  padding-left: 10px;
  border-left: 1px solid #e0e0e0;
  font-size: 13px;
  color: #37474f;
  min-width: 0;
  word-break: break-word;
}
.condition-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/global/CustomerFilters/GroupsDialog.vue